/**
 * @generated SignedSource<<bdf3a574579021a223915427da4ef1ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductComponent_Store$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ProductLinkedTodosFloatingAddButton_Store">;
  readonly " $fragmentType": "ProductComponent_Store";
};
export type ProductComponent_Store$key = {
  readonly " $data"?: ProductComponent_Store$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductComponent_Store">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductComponent_Store",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductLinkedTodosFloatingAddButton_Store"
    }
  ],
  "type": "Store",
  "abstractKey": null
};

(node as any).hash = "331875dc396b5a3eed7bbcf4a8b6bd62";

export default node;
